/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Persona } from './persona';
import { PersonaReportAllOf } from './personaReportAllOf';


/**
 * Informacion del responsable de una reserva.
 */
export interface PersonaReport { 
    /**
     * Documento de identidad del Responsable
     */
    documentoID: string;
    /**
     * Tipo de documento del responsable.
     */
    tipoDocumento: PersonaReport.TipoDocumentoEnum;
    /**
     * Titulo del responsable
     */
    nombre: string;
    /**
     * Apellido del responsable
     */
    apellido: string;
    /**
     * Telefono del responsable
     */
    telefono: string;
    /**
     * Correo del responsable
     */
    correo: string;
    /**
     * Genero del responsable
     */
    genero?: PersonaReport.GeneroEnum;
    /**
     * Fecha de nacimiento del responsable.
     */
    nacimiento?: string;
    /**
     * Monto abonado asignado para esta persona
     */
    abono?: number;
    /**
     * Monto debe, asignado para esta persona,
     */
    readonly debe?: number;
    /**
     * La nota para la persona
     */
    nota?: string;
    readonly alwaysNullField?: boolean;
    /**
     * El reserva id, asociada a la persona.
     */
    reservaId?: string;
}
export namespace PersonaReport {
    export type TipoDocumentoEnum = 'CEDULA_CIUDADANIA' | 'PASAPORTE' | 'CEDULA_EXTRANJERIA' | 'OTRO';
    export const TipoDocumentoEnum = {
        CEDULACIUDADANIA: 'CEDULA_CIUDADANIA' as TipoDocumentoEnum,
        PASAPORTE: 'PASAPORTE' as TipoDocumentoEnum,
        CEDULAEXTRANJERIA: 'CEDULA_EXTRANJERIA' as TipoDocumentoEnum,
        OTRO: 'OTRO' as TipoDocumentoEnum
    };
    export type GeneroEnum = 'F' | 'M';
    export const GeneroEnum = {
        F: 'F' as GeneroEnum,
        M: 'M' as GeneroEnum
    };
}


